// source: inv_non_serialized_inventory_message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var inv_common_message_pb = require('./inv_common_message_pb.js');
goog.object.extend(proto, inv_common_message_pb);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.repeatedFields_ = [7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
item: jspb.Message.getFieldWithDefault(msg, 3, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 4, 0),
unit: jspb.Message.getFieldWithDefault(msg, 5, ""),
description: jspb.Message.getFieldWithDefault(msg, 6, ""),
locationsList: jspb.Message.toObjectList(msg.getLocationsList(),
    proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.toObject, includeInstance),
adjustmentNotesList: jspb.Message.toObjectList(msg.getAdjustmentNotesList(),
    proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.toObject, includeInstance),
contractName: jspb.Message.getFieldWithDefault(msg, 9, ""),
contractTitle: jspb.Message.getFieldWithDefault(msg, 10, ""),
lowStockThreshold: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setItem(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnit(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 7:
      var value = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.deserializeBinaryFromReader);
      msg.addLocations(value);
      break;
    case 8:
      var value = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.deserializeBinaryFromReader);
      msg.addAdjustmentNotes(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractName(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractTitle(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLowStockThreshold(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getItem();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getUnit();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.serializeBinaryToWriter
    );
  }
  f = message.getAdjustmentNotesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.serializeBinaryToWriter
    );
  }
  f = message.getContractName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getContractTitle();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLowStockThreshold();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string item = 3;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.getItem = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.setItem = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 quantity = 4;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string unit = 5;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.getUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.setUnit = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated NonSerializedInventoryLocation locations = 7;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation>}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.getLocationsList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation, 7));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.setLocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.addLocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.clearLocationsList = function() {
  return this.setLocationsList([]);
};


/**
 * repeated AdjustmentNote adjustment_notes = 8;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote>}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.getAdjustmentNotesList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote, 8));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.setAdjustmentNotesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.addAdjustmentNotes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.clearAdjustmentNotesList = function() {
  return this.setAdjustmentNotesList([]);
};


/**
 * optional string contract_name = 9;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.getContractName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.setContractName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string contract_title = 10;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.getContractTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.setContractTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 low_stock_threshold = 11;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.getLowStockThreshold = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory.prototype.setLowStockThreshold = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
locationName: jspb.Message.getFieldWithDefault(msg, 2, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
nonSerializedInventoryId: jspb.Message.getFieldWithDefault(msg, 4, 0),
locationId: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocationName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNonSerializedInventoryId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLocationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocationName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getNonSerializedInventoryId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getLocationId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string location_name = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.prototype.getLocationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.prototype.setLocationName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 quantity = 3;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 non_serialized_inventory_id = 4;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.prototype.getNonSerializedInventoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.prototype.setNonSerializedInventoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 location_id = 5;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.prototype.getLocationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.prototype.setLocationId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
direction: jspb.Message.getFieldWithDefault(msg, 2, 0),
quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
unitType: jspb.Message.getFieldWithDefault(msg, 4, ""),
reason: jspb.Message.getFieldWithDefault(msg, 5, ""),
notes: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setDirection(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnitType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDirection();
  if (f !== 0) {
    writer.writeSint32(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getUnitType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sint32 direction = 2;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.prototype.getDirection = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.prototype.setDirection = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 quantity = 3;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string unit_type = 4;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.prototype.getUnitType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.prototype.setUnitType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string reason = 5;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string notes = 6;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
nonSerializedInventoryId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNonSerializedInventoryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNonSerializedInventoryId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 non_serialized_inventory_id = 1;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest.prototype.getNonSerializedInventoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByNonSerializedInventoryIdRequest.prototype.setNonSerializedInventoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
locationId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLocationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocationId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 location_id = 1;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest.prototype.getLocationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetByLocationIdRequest.prototype.setLocationId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
nonSerializedInventoryLocation: (f = msg.getNonSerializedInventoryLocation()) && proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.deserializeBinaryFromReader);
      msg.setNonSerializedInventoryLocation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNonSerializedInventoryLocation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.serializeBinaryToWriter
    );
  }
};


/**
 * optional NonSerializedInventoryLocation non_serialized_inventory_location = 1;
 * @return {?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest.prototype.getNonSerializedInventoryLocation = function() {
  return /** @type{?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation} */ (
    jspb.Message.getWrapperField(this, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation, 1));
};


/**
 * @param {?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest.prototype.setNonSerializedInventoryLocation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest.prototype.clearNonSerializedInventoryLocation = function() {
  return this.setNonSerializedInventoryLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationRequest.prototype.hasNonSerializedInventoryLocation = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
nonSerializedInventoryLocation: (f = msg.getNonSerializedInventoryLocation()) && proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.deserializeBinaryFromReader);
      msg.setNonSerializedInventoryLocation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNonSerializedInventoryLocation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.serializeBinaryToWriter
    );
  }
};


/**
 * optional NonSerializedInventoryLocation non_serialized_inventory_location = 1;
 * @return {?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse.prototype.getNonSerializedInventoryLocation = function() {
  return /** @type{?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation} */ (
    jspb.Message.getWrapperField(this, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation, 1));
};


/**
 * @param {?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse.prototype.setNonSerializedInventoryLocation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse.prototype.clearNonSerializedInventoryLocation = function() {
  return this.setNonSerializedInventoryLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationResponse.prototype.hasNonSerializedInventoryLocation = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
nonSerializedInventoryLocationsList: jspb.Message.toObjectList(msg.getNonSerializedInventoryLocationsList(),
    proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.deserializeBinaryFromReader);
      msg.addNonSerializedInventoryLocations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNonSerializedInventoryLocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated NonSerializedInventoryLocation non_serialized_inventory_locations = 1;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation>}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.prototype.getNonSerializedInventoryLocationsList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation, 1));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.prototype.setNonSerializedInventoryLocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.prototype.addNonSerializedInventoryLocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationListResponse.prototype.clearNonSerializedInventoryLocationsList = function() {
  return this.setNonSerializedInventoryLocationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
nonSerializedInventoryId: jspb.Message.getFieldWithDefault(msg, 1, 0),
locationId: jspb.Message.getFieldWithDefault(msg, 2, 0),
quantity: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNonSerializedInventoryId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLocationId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNonSerializedInventoryId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getLocationId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int64 non_serialized_inventory_id = 1;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.prototype.getNonSerializedInventoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.prototype.setNonSerializedInventoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 location_id = 2;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.prototype.getLocationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.prototype.setLocationId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 quantity = 3;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AddOrUpdateQuantityRequest.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
filter: (f = msg.getFilter()) && inv_common_message_pb.RequestDto.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new inv_common_message_pb.RequestDto;
      reader.readMessage(value,inv_common_message_pb.RequestDto.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      inv_common_message_pb.RequestDto.serializeBinaryToWriter
    );
  }
};


/**
 * optional Olameter.WFMS.InventoryManagement.Common.v1.RequestDto filter = 1;
 * @return {?proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest.prototype.getFilter = function() {
  return /** @type{?proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto} */ (
    jspb.Message.getWrapperField(this, inv_common_message_pb.RequestDto, 1));
};


/**
 * @param {?proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryLocationListRequest.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.toObject, includeInstance),
total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated NonSerializedInventoryLocation data = 1;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation>}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation, 1));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryLocationDataSourceResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.toObject = function(includeInstance, msg) {
  var f, obj = {
sourceLocationName: jspb.Message.getFieldWithDefault(msg, 1, ""),
nonSerializedInventoriesList: jspb.Message.toObjectList(msg.getNonSerializedInventoriesList(),
    proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceLocationName(value);
      break;
    case 2:
      var value = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.deserializeBinaryFromReader);
      msg.addNonSerializedInventories(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSourceLocationName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNonSerializedInventoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional string source_location_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.prototype.getSourceLocationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.prototype.setSourceLocationName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated NonSerializedInventoryTransferItem non_serialized_inventories = 2;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem>}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.prototype.getNonSerializedInventoriesList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem, 2));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.prototype.setNonSerializedInventoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.prototype.addNonSerializedInventories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer.prototype.clearNonSerializedInventoriesList = function() {
  return this.setNonSerializedInventoriesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.toObject = function(includeInstance, msg) {
  var f, obj = {
nonSerializedInventoryName: jspb.Message.getFieldWithDefault(msg, 1, ""),
transfersList: jspb.Message.toObjectList(msg.getTransfersList(),
    proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNonSerializedInventoryName(value);
      break;
    case 2:
      var value = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.deserializeBinaryFromReader);
      msg.addTransfers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNonSerializedInventoryName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTransfersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.serializeBinaryToWriter
    );
  }
};


/**
 * optional string non_serialized_inventory_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.prototype.getNonSerializedInventoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.prototype.setNonSerializedInventoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated TransferData transfers = 2;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData>}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.prototype.getTransfersList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData, 2));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.prototype.setTransfersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.prototype.addTransfers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferItem.prototype.clearTransfersList = function() {
  return this.setTransfersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.toObject = function(includeInstance, msg) {
  var f, obj = {
locationName: jspb.Message.getFieldWithDefault(msg, 1, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocationName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocationName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string location_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.prototype.getLocationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.prototype.setLocationName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.TransferData.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1);
